export default "__VITE_ASSET__Q0etuZ$e__"